import * as Icons from "./src/shared/assets/icons/icons";

const { basketSvg, homeIcon, catalogIcon, personIcon, basketIcon } = Icons;

export { basketSvg, homeIcon, catalogIcon, personIcon, basketIcon };
